import React, { useState } from "react";
import { useClasses, useI18n } from "../../";
import Widget from "./Widget";
import Actions from "./Actions";
const styles = (theme) => ({
    wrapper: {
        display: "inline-block",
    },
    menuSection: {
        margin: 0,
        fontWeight: 400,
        color: theme.palette.get("primary"),
        letterSpacing: "0.75px",
        fontSize: "1rem",
    },
    seperator: {
        margin: "10px -16px",
        height: "1px",
        backgroundColor: theme.palette.get("grey"),
    },
    list: {
        margin: "4px 0px 0px 0px",
        padding: 0,
        listStyle: "none",
        "& li": {
            margin: "0px -16px",
            padding: "8px 16px",
            cursor: "pointer",
            "&:hover": {
                backgroundColor: theme.palette.get("primary"),
                color: "#fff",
            },
        },
    },
    popUp: {
        padding: "8px 16px 0px 16px !important",
        height: "auto !important",
        overflowY: "auto !important",
    },
});
export default function Account(props) {
    const classes = useClasses(styles);
    const [open, setOpen] = useState(false);
    const i18n = useI18n("authentication");
    const anchor = React.useRef(null);
    return (React.createElement("div", { className: classes.wrapper, ref: anchor },
        React.createElement(Widget, { user: props.user, open: open, onChange: () => setOpen(!open) }),
        open && (React.createElement(Actions, { i18n: i18n, user: props.user, state: props.state, onSettings: props.onSettings, onTeamChange: props.onTeamChange, onTeamSettings: props.onTeamSettings, onTeamAdd: props.onTeamAdd, onSignOut: props.onSignOut, onClose: () => {
                setOpen(false);
            }, anchor: anchor }))));
}
